module.exports = __webpack_public_path__ + "img/select-lang-btn-fr.0de80044.png";